import { useState } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button/Button'
import { LoaderOverlay } from 'core-components/library/loader'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'

import styles from './DeleteDocumentDialogContent.module.scss'

interface IDeleteDocumentDialogContentProps {
  documentLabel: string
  onConfirm: () => Promise<unknown>
  onDeleted: () => void
  onError: (e: unknown) => void
  closeDialog: () => void
}

export const DeleteDocumentDialogContent = ({
  documentLabel,
  onConfirm,
  onDeleted,
  onError,
  closeDialog,
}: IDeleteDocumentDialogContentProps) => {
  const [wip, setWip] = useState(false)

  const onDelete = async () => {
    setWip(true)

    try {
      await onConfirm()
      onDeleted()
    } catch (e) {
      onError(e)
    } finally {
      setWip(false)
      closeDialog()
    }
  }

  return (
    <div className={styles.root}>
      <LoaderOverlay show={wip} />
      <h3 className={styles.title}>
        <Translation
          span
          text={FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks.actions.deleteConfirmTitle}
        />
      </h3>
      <p className={styles.message}>
        <Translation
          span
          text={FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks.actions.deleteConfirmMessage}
          replaceParams={[{ key: '{name}', value: documentLabel }]}
        />
      </p>
      <div className={styles.buttons}>
        <Button variant="contained" color="grey" onClick={closeDialog}>
          <Translation
            span
            text={FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks.actions.cancel}
          />
        </Button>
        <Button color="danger" onClick={onDelete}>
          <Translation
            span
            text={FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks.actions.deleteConfirmButton}
          />
        </Button>
      </div>
    </div>
  )
}

DeleteDocumentDialogContent.displayName = 'DeleteDocumentDialogContent'
